// Every string a RAD component owns, in the seven languages the product ships. A key carries all of
// them on one entry, so a language left out of a new string shows up while it is being written
// rather than as a fallback at runtime.
// 
// The RAD components are translated using your LLM of choice instead of POEditor, as this keeps
// the translations self contained and LLMs actually do a better job as they are context aware.
//
// A component owns its chrome: accessible names, the words on its own controls, the pagination
// readout. Text a screen supplies reaches the component through an input and is translated by the
// application. See standards/content.mdx § 9.
export const RAD_STRINGS: Record<string, Record<string, string>> = {
    'RAD.PAGINATION.LANDMARK': {
        en: 'Pagination',
        de: 'Seitennavigation',
        es: 'Paginación',
        fr: 'Pagination',
        it: 'Paginazione',
        nl: 'Paginering',
        pt: 'Paginação',
    },
    'RAD.PAGINATION.PER_PAGE': {
        en: 'Items per page',
        de: 'Einträge pro Seite',
        es: 'Elementos por página',
        fr: 'Éléments par page',
        it: 'Elementi per pagina',
        nl: 'Items per pagina',
        pt: 'Itens por página',
    },
    'RAD.PAGINATION.FIRST': {
        en: 'First page',
        de: 'Erste Seite',
        es: 'Primera página',
        fr: 'Première page',
        it: 'Prima pagina',
        nl: 'Eerste pagina',
        pt: 'Primeira página',
    },
    'RAD.PAGINATION.PREVIOUS': {
        en: 'Previous page',
        de: 'Vorherige Seite',
        es: 'Página anterior',
        fr: 'Page précédente',
        it: 'Pagina precedente',
        nl: 'Vorige pagina',
        pt: 'Página anterior',
    },
    'RAD.PAGINATION.NEXT': {
        en: 'Next page',
        de: 'Nächste Seite',
        es: 'Página siguiente',
        fr: 'Page suivante',
        it: 'Pagina successiva',
        nl: 'Volgende pagina',
        pt: 'Próxima página',
    },
    'RAD.PAGINATION.LAST': {
        en: 'Last page',
        de: 'Letzte Seite',
        es: 'Última página',
        fr: 'Dernière page',
        it: 'Ultima pagina',
        nl: 'Laatste pagina',
        pt: 'Última página',
    },
    'RAD.PAGINATION.POSITION': {
        en: 'Page {{ page }} of {{ pages }}',
        de: 'Seite {{ page }} von {{ pages }}',
        es: 'Página {{ page }} de {{ pages }}',
        fr: 'Page {{ page }} sur {{ pages }}',
        it: 'Pagina {{ page }} di {{ pages }}',
        nl: 'Pagina {{ page }} van {{ pages }}',
        pt: 'Página {{ page }} de {{ pages }}',
    },
    'RAD.PAGINATION.RANGE': {
        en: '{{ first }}–{{ last }} of {{ total }} results',
        de: '{{ first }}–{{ last }} von {{ total }} Ergebnissen',
        es: '{{ first }}–{{ last }} de {{ total }} resultados',
        fr: '{{ first }}–{{ last }} sur {{ total }} résultats',
        it: '{{ first }}–{{ last }} di {{ total }} risultati',
        nl: '{{ first }}–{{ last }} van {{ total }} resultaten',
        pt: '{{ first }}–{{ last }} de {{ total }} resultados',
    },
    'RAD.PAGINATION.NO_RESULTS': {
        en: 'No results',
        de: 'Keine Ergebnisse',
        es: 'Sin resultados',
        fr: 'Aucun résultat',
        it: 'Nessun risultato',
        nl: 'Geen resultaten',
        pt: 'Sem resultados',
    },
    'RAD.PAGINATION.ONE_RESULT': {
        en: '1 result',
        de: '1 Ergebnis',
        es: '1 resultado',
        fr: '1 résultat',
        it: '1 risultato',
        nl: '1 resultaat',
        pt: '1 resultado',
    },
    'RAD.TABS.MORE': {
        en: 'More',
        de: 'Mehr',
        es: 'Más',
        fr: 'Plus',
        it: 'Altro',
        nl: 'Meer',
        pt: 'Mais',
    },
    'RAD.INPUT.CLEAR': {
        en: 'Clear',
        de: 'Löschen',
        es: 'Borrar',
        fr: 'Effacer',
        it: 'Cancella',
        nl: 'Wissen',
        pt: 'Limpar',
    },
    'RAD.DATE_INPUT.CHOOSE': {
        en: 'Choose a date',
        de: 'Datum auswählen',
        es: 'Elegir una fecha',
        fr: 'Choisir une date',
        it: 'Scegli una data',
        nl: 'Kies een datum',
        pt: 'Escolher uma data',
    },
    'RAD.CALENDAR.PREVIOUS_MONTH': {
        en: 'Previous month',
        de: 'Vorheriger Monat',
        es: 'Mes anterior',
        fr: 'Mois précédent',
        it: 'Mese precedente',
        nl: 'Vorige maand',
        pt: 'Mês anterior',
    },
    'RAD.CALENDAR.NEXT_MONTH': {
        en: 'Next month',
        de: 'Nächster Monat',
        es: 'Mes siguiente',
        fr: 'Mois suivant',
        it: 'Mese successivo',
        nl: 'Volgende maand',
        pt: 'Próximo mês',
    },
};
